module.exports = __webpack_public_path__ + "img/reserved_selected.6a86ef0e.svg";